import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import FilterIcon from 'icons/Filter.icon';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { FilterOption } from 'models/Filters';
import MultiFilterModal from 'components/MultiFilterModal';

import './MultiFilter.styles.scss';

type MultiFilterProps = {
  className?: string;
  filterOptions: FilterOption[];
};

const MultiFilter: React.FC<MultiFilterProps> = (props) => {
  const { className, filterOptions } = props;

  const [multiFilter, multiFilterRef] = useCallbackRef<ModalRef>();

  const classes = classNames('multi-filter', className);

  return (
    <>
      <Button
        className={classes}
        variant="icon"
        icon={FilterIcon}
        onClick={multiFilter?.open}
      />
      <MultiFilterModal ref={multiFilterRef} filters={filterOptions} />
    </>
  );
};

export default MultiFilter;
